import { combineReducers } from 'redux';

import flash from 'store/features/common/flash/reducer.js';
import confirmationDialog from 'store/features/common/confirmation-dialog/reducer.js';

export default combineReducers({
  flash,
  confirmationDialog,
});



// WEBPACK FOOTER //
// ./src/store/features/common/reducer.js